import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthServiceCustom } from '../../core/auth/authServiceCustom';
import { AppConfig } from '../../core/_config/app.config';
import { CustomResponse } from '../../interfaces/CustomResponse';
import { EntityPeriod } from '../../interfaces/EntityPeriod';
@Injectable({
    providedIn: 'root',
})
export class EntityService {
    private API_URL = this.config.urlApi + this.config.versionApi;
    constructor(private http: HttpClient, private config: AppConfig, private authServiceCustom: AuthServiceCustom) {}

    getPeriodsByEntity(entityId: string): Observable<CustomResponse<EntityPeriod>> {
        return this.http.get<CustomResponse<EntityPeriod>>(`${this.API_URL}Entity/GetPeriodByEntity/${entityId}`);
    }

    async GetEntityIdByLegalEntityId(legalEntityId: string): Promise<CustomResponse<string>> {
        return await this.http
            .get<CustomResponse<string>>(`${this.API_URL}Entity/GetEntityIdByLegalEntityId/${legalEntityId}`)
            .toPromise();
    }

    GetEntityChildByEntityId(entityId: string): Observable<any> {
        return this.http.get<CustomResponse<string>>(`${this.API_URL}Entity/GetEntityChildByEntityId/${entityId}`);
    }

    GetEntity(entityId: string): Observable<any> {
        return this.http.get<CustomResponse<any>>(`${this.API_URL}Entity/${entityId}`);
    }
}
